// extracted by mini-css-extract-plugin
export default {"iframe":"signature-iframe_iframe__LgJzB"};